import styled from 'styled-components';
import { blue1, blue2, gray1, gray3, gray4 } from '@styles/styled/variables';

export const VersionWrapper = styled.div`
  background-color: white;
  border: 1px solid ${({ active }) => (active ? blue1 : gray1)};
  border-radius: 8px;
  display: inline-block;
  margin: 0 0 20px 20px;
  color: ${gray1};
  padding-bottom: 24px;
  min-width: 280px;
`;

export const Header = styled.h3`
  position: relative;
  margin-bottom: 0;
  font-weight: bold;
  padding: 8px 0 0 16px;
  color: ${gray1};

  button {
    position: absolute;
    right: 0;
    top: 8px;
  }
`;

export const ShareHeader = styled.th`
  font-weight: bold;
  width: 32px;
`;

const paddingLeft = '16px';

export const Info = styled.div`
  padding: 0 0 8px ${paddingLeft};
  font-size: 14px;
`;

export const Name = styled.span`
  max-width: calc(100% - 110px);
  padding-right: 8px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: normal;
  font-size: 20px;
`;

export const TitleSection = styled.div`
  background-color: ${({ active }) => (active ? blue2 : gray3)};
  border-radius: 8px 8px 0 0;
`;

export const Title = styled.span`
  font-style: italic;
  min-width: 140px;
  display: inline-block;
`;
